import { makeVar } from '@apollo/client';
import { ICatalogFilterOptions } from 'interfaces/catalog';
import { INetworkInstrumentNode, INetworkNode, INetworkSearchOption } from 'interfaces/network';

import LINKS from '@/constants/links';
import { TThemeState } from '@/constants/theme';

/**
 * Start of vars used on Header Component
 */
let defaultHeader = LINKS.HEADER.DEFAULT;
let subMenuData = LINKS.HEADER.DEFAULT.map((subMenu, index: number) => {
	return subMenu;
});

// if (appEnv === 'production') {
//   defaultHeader = LINKS.HEADER.DEFAULT.filter((nav) => nav.link !== '/dvrf')
// }

// Used for the header links on the navigation bar
export const headerLinksData = makeVar(defaultHeader);
export const headerLinksSubMenuData = makeVar(subMenuData);

// Controls the website theme state
export const appTheme = makeVar<TThemeState | null>(null);

// Controls header state value specifically background and header visibility
export const headerStateProps = makeVar<{
	showBackground: boolean;
	showHeader: boolean;
}>({
	showBackground: false,
	showHeader: true,
});

/**
 * Start of vars used on Networks Page
 */
export const selectedNetwork = makeVar<INetworkNode | undefined>(undefined);

export const selectedNetworkFilter = makeVar<undefined | INetworkSearchOption[]>(undefined);

export const selectedPair = makeVar<INetworkInstrumentNode[] | undefined>(undefined);

/**
 * Start of vars used on Catalog Page
 */
export const selectedCatalogFilter = makeVar<ICatalogFilterOptions[] | undefined>(undefined);
